import { gql } from "lib/apolloClient";

export const attachmentItem = gql`
  fragment attachmentItem on Attachment {
    id
    name
    title
    type
    mimeType
    url
    signedUrl
    metadata
    parentType
    isRead
    createdBy {
      id
      type
    }
    lockingState {
      state
      scheduledAt
    }
  }
`;
